import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropVote } from "./SingleWaveDropVote";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface SingleWaveDropInfoActionsProps {
  readonly drop: ExtendedDrop;
  readonly className?: string;
}
export const SingleWaveDropInfoActions: React.FC<SingleWaveDropInfoActionsProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    className: t1
  } = t0;
  const className = t1 === undefined ? "tw-px-6" : t1;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const t2 = `tw-flex tw-flex-col tw-gap-y-2 tw-mt-4 tw-pt-4 tw-border-t tw-border-iron-700 tw-border-solid tw-border-x-0 tw-border-b-0 ${className}`;
  let t3;
  if ($[0] !== canShowVote || $[1] !== drop) {
    t3 = canShowVote && <SingleWaveDropVote drop={drop} />;
    $[0] = canShowVote;
    $[1] = drop;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};